module.exports = __webpack_public_path__ + "img/collectiongallery_forestgreen@2x.6af3e8f.webp";